import { render } from "./EditPaymentLiquidation1.vue?vue&type=template&id=1070526f"
import script from "./EditPaymentLiquidation1.vue?vue&type=script&lang=js"
export * from "./EditPaymentLiquidation1.vue?vue&type=script&lang=js"

import "./EditPaymentLiquidation1.vue?vue&type=style&index=0&id=1070526f&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__